(function () {
  const pageLoadedAt = Date.now();

  document.addEventListener(
    "submit",
    function (e) {
      const form = e.target;

      if (!form || !form.classList || !form.classList.contains("contact-form__form")) {
        return;
      }

      const honeypot = form.querySelector('input[name="contact[company_website]"]');
      const timeTaken = Date.now() - pageLoadedAt;

      if (honeypot && honeypot.value.trim() !== "") {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }

      if (timeTaken < 3000) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
    },
    true
  );
})();